/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProviderEnum } from '../models';
// @ts-ignore
import type { UpdateVivaConfigAdminDto } from '../models';
// @ts-ignore
import type { UpdateVivaConfigOpsDto } from '../models';
// @ts-ignore
import type { VivaConfigResponseDto } from '../models';
/**
 * VivaApi - axios parameter creator
 * @export
 */
export const VivaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {GetVivaConfigChannelEnum} channel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVivaConfig: async (businessId: number, channel: GetVivaConfigChannelEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('getVivaConfig', 'businessId', businessId)
            // verify required parameter 'channel' is not null or undefined
            assertParamExists('getVivaConfig', 'channel', channel)
            const localVarPath = `/api/v1/viva/config/{businessId}`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} businessId 
         * @param {UpdateVivaConfigChannelEnum} channel 
         * @param {UpdateVivaConfigAdminDto} updateVivaConfigAdminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVivaConfig: async (businessId: number, channel: UpdateVivaConfigChannelEnum, updateVivaConfigAdminDto: UpdateVivaConfigAdminDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('updateVivaConfig', 'businessId', businessId)
            // verify required parameter 'channel' is not null or undefined
            assertParamExists('updateVivaConfig', 'channel', channel)
            // verify required parameter 'updateVivaConfigAdminDto' is not null or undefined
            assertParamExists('updateVivaConfig', 'updateVivaConfigAdminDto', updateVivaConfigAdminDto)
            const localVarPath = `/api/v1/viva/config/{businessId}`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVivaConfigAdminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} businessId 
         * @param {ProviderEnum} channel 
         * @param {UpdateVivaConfigOpsDto} updateVivaConfigOpsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVivaRates: async (businessId: number, channel: ProviderEnum, updateVivaConfigOpsDto: UpdateVivaConfigOpsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessId' is not null or undefined
            assertParamExists('updateVivaRates', 'businessId', businessId)
            // verify required parameter 'channel' is not null or undefined
            assertParamExists('updateVivaRates', 'channel', channel)
            // verify required parameter 'updateVivaConfigOpsDto' is not null or undefined
            assertParamExists('updateVivaRates', 'updateVivaConfigOpsDto', updateVivaConfigOpsDto)
            const localVarPath = `/api/v1/viva/config/{businessId}/rate`
                .replace(`{${"businessId"}}`, encodeURIComponent(String(businessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateVivaConfigOpsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VivaApi - functional programming interface
 * @export
 */
export const VivaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VivaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {GetVivaConfigChannelEnum} channel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVivaConfig(businessId: number, channel: GetVivaConfigChannelEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VivaConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVivaConfig(businessId, channel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VivaApi.getVivaConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} businessId 
         * @param {UpdateVivaConfigChannelEnum} channel 
         * @param {UpdateVivaConfigAdminDto} updateVivaConfigAdminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVivaConfig(businessId: number, channel: UpdateVivaConfigChannelEnum, updateVivaConfigAdminDto: UpdateVivaConfigAdminDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VivaConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVivaConfig(businessId, channel, updateVivaConfigAdminDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VivaApi.updateVivaConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} businessId 
         * @param {ProviderEnum} channel 
         * @param {UpdateVivaConfigOpsDto} updateVivaConfigOpsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVivaRates(businessId: number, channel: ProviderEnum, updateVivaConfigOpsDto: UpdateVivaConfigOpsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VivaConfigResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVivaRates(businessId, channel, updateVivaConfigOpsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VivaApi.updateVivaRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VivaApi - factory interface
 * @export
 */
export const VivaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VivaApiFp(configuration)
    return {
        /**
         * 
         * @param {number} businessId 
         * @param {GetVivaConfigChannelEnum} channel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVivaConfig(businessId: number, channel: GetVivaConfigChannelEnum, options?: RawAxiosRequestConfig): AxiosPromise<VivaConfigResponseDto> {
            return localVarFp.getVivaConfig(businessId, channel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} businessId 
         * @param {UpdateVivaConfigChannelEnum} channel 
         * @param {UpdateVivaConfigAdminDto} updateVivaConfigAdminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVivaConfig(businessId: number, channel: UpdateVivaConfigChannelEnum, updateVivaConfigAdminDto: UpdateVivaConfigAdminDto, options?: RawAxiosRequestConfig): AxiosPromise<VivaConfigResponseDto> {
            return localVarFp.updateVivaConfig(businessId, channel, updateVivaConfigAdminDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} businessId 
         * @param {ProviderEnum} channel 
         * @param {UpdateVivaConfigOpsDto} updateVivaConfigOpsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVivaRates(businessId: number, channel: ProviderEnum, updateVivaConfigOpsDto: UpdateVivaConfigOpsDto, options?: RawAxiosRequestConfig): AxiosPromise<VivaConfigResponseDto> {
            return localVarFp.updateVivaRates(businessId, channel, updateVivaConfigOpsDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VivaApi - object-oriented interface
 * @export
 * @class VivaApi
 * @extends {BaseAPI}
 */
export class VivaApi extends BaseAPI {
    /**
     * 
     * @param {number} businessId 
     * @param {GetVivaConfigChannelEnum} channel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VivaApi
     */
    public getVivaConfig(businessId: number, channel: GetVivaConfigChannelEnum, options?: RawAxiosRequestConfig) {
        return VivaApiFp(this.configuration).getVivaConfig(businessId, channel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} businessId 
     * @param {UpdateVivaConfigChannelEnum} channel 
     * @param {UpdateVivaConfigAdminDto} updateVivaConfigAdminDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VivaApi
     */
    public updateVivaConfig(businessId: number, channel: UpdateVivaConfigChannelEnum, updateVivaConfigAdminDto: UpdateVivaConfigAdminDto, options?: RawAxiosRequestConfig) {
        return VivaApiFp(this.configuration).updateVivaConfig(businessId, channel, updateVivaConfigAdminDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} businessId 
     * @param {ProviderEnum} channel 
     * @param {UpdateVivaConfigOpsDto} updateVivaConfigOpsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VivaApi
     */
    public updateVivaRates(businessId: number, channel: ProviderEnum, updateVivaConfigOpsDto: UpdateVivaConfigOpsDto, options?: RawAxiosRequestConfig) {
        return VivaApiFp(this.configuration).updateVivaRates(businessId, channel, updateVivaConfigOpsDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetVivaConfigChannelEnum = {
    Wolt: 'Wolt',
    MunchiOnline: 'MunchiOnline',
    MunchiKiosk: 'MunchiKiosk',
    MunchiPos: 'MunchiPos',
    UberEats: 'UberEats',
    Foodora: 'Foodora',
    Bolt: 'Bolt',
    MunchiKioskV2: 'MunchiKioskV2',
    Kiosk: 'Kiosk',
    WoltStorefront: 'WoltStorefront',
    Storefront: 'Storefront',
    MunchiPay: 'MunchiPay'
} as const;
export type GetVivaConfigChannelEnum = typeof GetVivaConfigChannelEnum[keyof typeof GetVivaConfigChannelEnum];
/**
 * @export
 */
export const UpdateVivaConfigChannelEnum = {
    Wolt: 'Wolt',
    MunchiOnline: 'MunchiOnline',
    MunchiKiosk: 'MunchiKiosk',
    MunchiPos: 'MunchiPos',
    UberEats: 'UberEats',
    Foodora: 'Foodora',
    Bolt: 'Bolt',
    MunchiKioskV2: 'MunchiKioskV2',
    Kiosk: 'Kiosk',
    WoltStorefront: 'WoltStorefront',
    Storefront: 'Storefront',
    MunchiPay: 'MunchiPay'
} as const;
export type UpdateVivaConfigChannelEnum = typeof UpdateVivaConfigChannelEnum[keyof typeof UpdateVivaConfigChannelEnum];
